import * as React from 'react'
import { IconList } from '../../components/UI/IconList'
import { InfoList } from '../../components/UI/InfoList'
import { TeaserCard } from '../../components/UI/TeaserCard'
import { ThemeName } from '../../lib/constants'
import { useProduct } from '../../lib/hooks/useProduct'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { IconListItem } from '../../components/UI/IconList/types'
import { ContentWrapper, Excerpt, Footer, InfoListWrapper } from './styled'
import { TeaserCardProductItemProps } from './types'

export const TeaserCardProductItem = ({
  blok,
  children,
  justify = 'left',
  step,
  href,
  buttonLabel,
}: TeaserCardProductItemProps) => {
  const products = useProduct({ id: blok.select_product })

  const { content, full_slug } = products || {}

  const operationSystems = content?.operationsSystems || []
  const productVariants = content?.productVariant || []
  const osIcons = operationSystems.map(os => ({ icon: os.content.icon, name: os.content.name })) || []
  const productVariantIcons = productVariants.map(pv => ({ icon: pv.content.icon, name: pv.content.name })) || []

  const icons = [...osIcons, ...productVariantIcons]

  if (!content) {
    return null
  }

  return (
    <TeaserCard
      isProductItem
      href={`/${full_slug}`}
      title={content.productName}
      asset={content.productIcon}
      step={step}
      justify="center"
    >
      <ContentWrapper>
        {content.description && <Excerpt>{renderRichtext(content.description)}</Excerpt>}
        <Footer>
          <IconList justify="center" icons={icons as IconListItem[]} tooltipNowrap />
          <InfoListWrapper>
            <InfoList justify="center" text={content.technologies} />
          </InfoListWrapper>
        </Footer>
      </ContentWrapper>
    </TeaserCard>
  )
}
